import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MapState } from './model';
import { Slot } from '../cleaners/model';

const initialState: MapState = {
  currentCleanerId: null,
  currentBooking: {
    selectedSlots: [],
  },
};

export const mapSlice = createSlice({
  name: 'cleaners',
  initialState,
  reducers: {
    setCurrentCleanerID(state, { payload }: PayloadAction<string>) {
      state.currentCleanerId = payload;
    },
    resetCurrentCleanerID(state) {
      state.currentCleanerId = initialState.currentCleanerId;
    },
    setCurrentBookingDay(state, { payload }: PayloadAction<number>) {
      state.currentBooking.selectedDay = payload;
    },
    resetBooking(state) {
      state.currentBooking = initialState.currentBooking;
    },
  },
});

export const mapActions = { ...mapSlice.actions };

export const mapReducer = mapSlice.reducer;
